import React, {  } from 'react';
import './PlaywatchKidsComponent.scss';
import { PlaywatchKidsProvider } from './playwatch/Context';
import MainComponent from './playwatch/MainComponent';
type Props = {};

const PlaywatchKidsComponent: React.FC<Props> = ({
}) => {
    return (
        <PlaywatchKidsProvider>
            <MainComponent />
        </PlaywatchKidsProvider>
    );
};

export default PlaywatchKidsComponent;
